export const ordersEn: Record<string, string> = {
  // Orders
  'your_orders': 'Your Orders',
  'unpaid_invoice': 'unpaid invoice',
  'unpaid_invoices': 'unpaid invoices',
  'orders_total': 'orders total',
  'order_total': 'order total',
  'start_dress_journey': 'Start Your Dress Journey',
  'no_orders_message': "You don't have any orders yet. Book an appointment to begin your custom dress experience.",
  'order_details': 'Order Details',
  'total_amount': 'Total Amount',
  'deposit': 'Deposit',
  'discount': 'Discount',
  'percentage_discount': 'Percentage Discount',
  'fixed_discount': 'Fixed Discount',
  'financial_summary': 'Financial Summary',
  'payment_status': 'Payment Status',
  'deposit_required': 'Deposit Required',
  'total_paid': 'Total Paid',
  'outstanding_balance': 'Outstanding Balance',
  'invoices_created': 'Invoices Created',
  'manage_payments': 'Manage Payments',
  'important_dates': 'Important Dates',
  'expected_ready_date': 'Expected Ready Date',
  'second_fitting': 'Second Fitting',
  'delivery_date': 'Delivery Date',
  'order_timeline': 'Order Timeline',
  'invoices': 'Invoices',
  'pay_now': 'Pay Now',
  'paid': 'Paid',
  'partial': 'Partial',
  'invoice_status_draft': 'Draft',
  'invoice_status_issued': 'Issued',
  'invoice_status_paid': 'Paid',
  'payment_request_status_pending': 'Pending',
  'payment_request_status_sent': 'Sent',
  'payment_request_status_paid': 'Paid',
  'payment_request_status_overdue': 'Overdue',
  'payment_method_cash': 'Cash',
  'payment_method_card': 'Card',
  'payment_method_bank_transfer': 'Bank Transfer',
  'payment_method_other': 'Other',

  // Status labels (uppercase)
  'deposit_paid_caps': 'DEPOSIT PAID',
  'invoices_caps': 'INVOICES',
  'cash_caps': 'CASH',
  'order_placed_caps': 'ORDER PLACED',
  'deposit_received_caps': 'DEPOSIT RECEIVED',
  'no_completed_orders_found_caps': 'NO COMPLETED ORDERS FOUND',
  'pending_caps': 'PENDING',
  'paid_caps': 'PAID',
  'unpaid_caps': 'UNPAID',
  'draft_caps': 'DRAFT',
  'open_caps': 'OPEN',
  'confirmed_caps': 'CONFIRMED',
  'in_progress_caps': 'IN PROGRESS',
  'completed_caps': 'COMPLETED',
  'cancelled_caps': 'CANCELLED',
  'archived_caps': 'ARCHIVED',
  'ready_caps': 'READY',
  'production_caps': 'PRODUCTION',
  'new_caps': 'NEW',
  'contacted_caps': 'CONTACTED',
  'qualified_caps': 'QUALIFIED',
  'proposal_sent_caps': 'PROPOSAL SENT',
  'won_caps': 'WON',
  'lost_caps': 'LOST',
  'active_caps': 'ACTIVE',
  'overdue_caps': 'OVERDUE',
  'due_caps': 'DUE',

  // Orders page specific
  'manage_dress_orders': 'Manage dress orders and track progress',
  'order_management': 'Order Management',
  'search_orders_placeholder': 'Search by order number, customer, or product name...',
  'filter_by_status': 'Filter by status',
  'all_statuses': 'All Statuses',
  'draft': 'Draft',
  'open': 'Open',
  'confirmed': 'Confirmed',
  'cancelled': 'Cancelled',
  'archived': 'Archived',
  'order_number': 'Order #',
  'customer': 'Customer',
  'balance_due': 'Balance Due',
  'due_date': 'Due Date',
  'status': 'Status',
  'unknown_customer': 'Unknown Customer',
  'no_products': 'No products',
  'unknown_product': 'Unknown Product',
  'no_orders_found_criteria': 'No orders found matching your criteria',
  'no_orders_created_yet': 'No orders created yet',
  'order_deleted_successfully': 'Order deleted successfully',
  'failed_to_delete_order': 'Failed to delete order',
  'failed_to_fetch_orders': 'Failed to fetch orders',
  'orders.customer.loadOrdersError': 'Failed to load orders. Please try again.',
  'orders.customer.loadOrderDetailsError': 'Failed to load order details. Please try again.',
  'orders.customer.createPaymentError': 'Failed to create payment. Please try again.',
  'confirm_delete_order': 'Are you sure you want to delete this order?',
  'archive': 'Archive',
  'back_to': 'Back to',
  'no_items': 'No items',
  'overdue': 'Overdue',
  'order_archived_successfully': 'Order archived successfully',
  'failed_to_archive_order': 'Failed to archive order',
  'save_changes': 'Save changes',
  'payment_overview': 'Payment overview',

  // Order details
  'order': 'Order',
  'production': 'Production',
  'ready': 'Ready',
  'total_amount_colon': 'Total Amount:',
  'deposit_colon': 'Deposit:',
  'expected_ready_date_colon': 'Expected Ready Date:',
  'due': 'Due',
  'unpaid': 'Unpaid',
  'pay_soon': 'Pay (Soon)',
  'deposit_paid': 'Deposit Paid',
  'no_completed_orders_found': 'No completed orders found',
  'customer_information': 'Customer Information',
  'name_colon': 'Name:',
  'email_colon': 'Email:',
  'phone_colon': 'Phone:',
  'internal_notes': 'Internal Notes',
  'alteration_tasks': 'Alteration Tasks',
  'no_alteration_tasks_found': 'No alteration tasks found',
  'order_created': 'Order Created',
  'order_updated_event': 'Order Updated',
  'invoice_created_event': 'Invoice Created',
  'payment_received_event': 'Payment Received',
  'payment_request_created_event': 'Payment Request Created',
  'task_created_event': 'Task Created',
  'task_completed_event': 'Task Completed',
  'no_timeline_events': 'No events found',
  'status_updated': 'Order status updated successfully',
  'failed_update_status': 'Failed to update order status',
  'task_status_updated': 'Task status updated successfully',
  'failed_update_task_status': 'Failed to update task status',
  'delivery_date_colon': 'Delivery Date:',
  'payment_history': 'Payment History',
  'no_payments_yet': 'No payments yet',
  'completed_status': 'Completed',
  'first_fitting_colon': 'First Fitting:',
  'second_fitting_colon': 'Second Fitting:',
  'due_date_colon': 'Due Date:',
  'payment_successful': 'Payment Successful',
  'payment_processed_successfully': 'Payment processed successfully',

  // Orders filters & sorting
  'orders.filters.title': 'Filters',
  'orders.filters.createdDate': 'Created Date',
  'orders.filters.dueDate': 'Due Date',
  'orders.filters.dateRange': 'Date Range',
  'orders.filters.orderTotal': 'Order Total',
  'orders.filters.outstandingBalance': 'Outstanding Balance',
  'orders.filters.amount': 'Amount',
  'orders.filters.from': 'From',
  'orders.filters.to': 'To',
  'orders.filters.min': 'Min',
  'orders.filters.max': 'Max',
  'orders.filters.hasUnpaidBalance': 'Has unpaid balance only',
  'orders.filters.clearAll': 'Clear All',
  'orders.filters.apply': 'Apply Filters',
  'orders.filters.category': 'Category',
  'orders.filters.product': 'Product',
  'orders.filters.hasUnrequestedAmount': 'Has unrequested amount',
  'orders.filters.includeArchived': 'Include archived orders',
  'orders.sort.recentlyCreated': 'Recently Created',
  'orders.sort.oldestFirst': 'Oldest First',
  'orders.sort.amountHighLow': 'Amount: High to Low',
  'orders.sort.amountLowHigh': 'Amount: Low to High',
  'orders.sort.dueDateSoonest': 'Due Date: Soonest',
  'orders.sort.orderNumber': 'Order Number',
  'orders.empty.noResults': 'No orders found matching your filters',
  'orders.empty.noOrders': 'No orders yet',
  'orders.empty.noOrdersDesc': 'Create your first order to get started.',
  'orders.empty.clearFilters': 'Clear Filters',
  'orders.pagination.showing': 'Showing {from}-{to} of {total} orders',
  'orders.stats.totalOrders': 'Total Orders',
  'orders.stats.totalAmount': 'Total Amount',
  'orders.stats.active': 'Active',
  'orders.stats.unpaidBalance': 'Unpaid Balance',
  'orders.stats.unrequestedAmount': 'Unrequested',
  'orders.stats.overdue': 'Overdue',
  'orders.stats.show': 'Show stats',
  'orders.stats.hide': 'Hide stats',
  'orders.columns.toggle': 'Columns',
  'orders.table.order': 'Order',
  'orders.table.items': 'Items',
  'orders.table.amount': 'Amount',
  'orders.table.itemCount': '{count} items',
  'orders.table.itemSingle': '1 item',
  'orders.table.noItems': 'No items',
  'orders.table.balanceDue': 'balance due',
  'orders.table.paid': 'Paid',
  'orders.table.dueSoon': 'Due soon',
  'orders.table.overdueLabel': 'Overdue',
  'orders.table.unrequested': 'Unrequested',
  'orders.table.fullyRequested': 'Fully Requested',
  'orders.table.toRequest': 'to request',
  'orders.subtitle': '{count} orders',

  // Order Create Dialog
  'orders.create.title': 'Create New Order',
  'orders.create.description': 'Create a new dress order for a customer with measurements',
  'orders.create.tabs.productsCustomer': 'Products & Customer',
  'orders.create.tabs.measurementsDetails': 'Measurements & Details',
  'orders.create.customer': 'Customer *',
  'orders.create.selectCustomer': 'Select a customer',
  'orders.create.products': 'Products *',
  'orders.create.addProduct': 'Add Product',
  'orders.create.noProducts': 'No products added yet',
  'orders.create.noProductsHint': 'Click "Add Product" to get started',
  'orders.create.product': 'Product',
  'orders.create.selectProduct': 'Select product',
  'orders.create.quantity': 'Quantity',
  'orders.create.price': 'Price',
  'orders.create.discount': 'Discount (Optional)',
  'orders.create.discountAmount': 'Amount €',
  'orders.create.discountPercent': 'Percent %',
  'orders.create.discountExceedsSubtotal': 'Discount cannot exceed subtotal',
  'orders.create.subtotal': 'Subtotal:',
  'orders.create.discountLabel': 'Discount ({details}):',
  'orders.create.totalAmount': 'Total Amount:',
  'orders.create.measurementSet': 'Measurement Set *',
  'orders.create.selectMeasurementSet': 'Select measurement set',
  'orders.create.noMeasurements': 'No measurements found for this customer. Please add measurements first.',
  'orders.create.deposit': 'Deposit Amount (€)',
  'orders.create.dueDate': 'Due Date *',
  'orders.create.notes': 'Internal Notes',
  'orders.create.notesPlaceholder': 'Add any internal notes about this order...',
  'orders.create.next': 'Next: Measurements & Details',
  'orders.create.back': 'Back',
  'orders.create.creating': 'Creating...',
  'orders.create.createOrder': 'Create Order',
  'orders.create.success': 'Order created successfully',
  'orders.create.error': 'Failed to create order',
  'orders.create.version': 'Version',
  'orders.create.searchCustomer': 'Search by name or email...',
  'orders.create.noCustomerFound': 'No customer found.',
  'orders.create.orderDate': 'Order Date',
  'orders.create.orderDateHint': 'Leave empty for today\'s date',
  'orders.create.setCustomOrderDate': 'Set custom order date',
  'orders.create.searchProducts': 'Search by name, SKU or brand...',
  'orders.create.allCategories': 'All',
  'orders.create.noProductsFound': 'No products found',
  'orders.create.changeProduct': 'Change',

  // Orders page actions
  'orders.deleteTitle': 'Delete Order',
  'orders.deleteConfirmation': 'Are you sure you want to delete this order?',
  'orders.deleteWarning': 'The order will be deleted and can only be restored by contacting support.',
  'orders.actions.deleteOrder': 'Delete Order',
};
